/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TeamsMessage
 */
export interface TeamsMessage {
    /**
     * 
     * @type {string}
     * @memberof TeamsMessage
     */
    recipient: string;
    /**
     * 
     * @type {string}
     * @memberof TeamsMessage
     */
    text: string;
}

export function TeamsMessageFromJSON(json: any): TeamsMessage {
    return TeamsMessageFromJSONTyped(json, false);
}

export function TeamsMessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamsMessage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'recipient': json['recipient'],
        'text': json['text'],
    };
}

export function TeamsMessageToJSON(value?: TeamsMessage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'recipient': value.recipient,
        'text': value.text,
    };
}


